import { footerColumns } from '@/mocks/home';

export default function SiteFooter() {
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="w-full bg-background-200 border-t border-background-300 px-4 md:px-8 pt-12 md:pt-16 pb-8">
      <div className="w-full max-w-[1180px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-6 gap-8 lg:gap-6">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-water-flash-line text-xl"></i>
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950">吃瓜黑料网</span>
            </div>
            <p className="mt-4 text-xs md:text-sm text-foreground-600 leading-relaxed max-w-sm">
              吃瓜黑料网资源汇总页，把全站爆料板块与内容索引收在一页里。热门事件、人物黑料、瓜料分类一页总览，站点导航与板块索引随时可查。
            </p>
            <div className="mt-5 flex items-center gap-2 flex-wrap">
              <span className="px-2.5 py-1 rounded-md bg-background-50 border border-background-300 text-[11px] text-foreground-600 whitespace-nowrap">
                每日多次更新
              </span>
              <span className="px-2.5 py-1 rounded-md bg-background-50 border border-background-300 text-[11px] text-foreground-600 whitespace-nowrap">
                12 个索引板块
              </span>
              <span className="px-2.5 py-1 rounded-md bg-background-50 border border-background-300 text-[11px] text-foreground-600 whitespace-nowrap">
                时间线归档
              </span>
            </div>
          </div>

          <div className="lg:col-span-4 grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-6">
            {footerColumns.map((column) => (
              <div key={column.id}>
                <h3 className="text-sm text-foreground-900 font-medium mb-4">{column.title}</h3>
                <ul className="flex flex-col gap-3">
                  {column.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#board-index"
                        className="text-xs md:text-sm text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-foreground-500 leading-relaxed">
            © 2026 吃瓜黑料网 · 本站为内容索引与资源汇总展示页，所有板块内容均为演示数据，不构成任何事实陈述。
          </p>
          <button
            type="button"
            onClick={scrollTop}
            className="inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-background-50 border border-background-300 hover:border-primary-400 text-xs text-foreground-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-up-line"></i>
            回到顶部
          </button>
        </div>
      </div>
    </footer>
  );
}